module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAYAAACaJFpUAAAAAXNSR0IArs4c6QAAAOlJREFUSA3tl8EKgkAQhp1d65YIQVCglw49QO//CD1Ah0iU6hRsdumwu8ZGs4jgijBeZLwMOuP3Mx97WYgGnkOW7TTAdmDs146b5nGuqntoVoaaY8IcxwKsNkkCz7p+93Fhn+fHvuYU38UU0BBz/oGh7efRA1xj6tN6KcuTy5r/oeEN8UyRVVZKphJBrBRNkFVWSqYSQawUTZBVVkqmEkGsFE2QVa9Ua7Bk1A6ozfaBC2nrzhzZa5vtA7WUN2OEIUv5gxzTsZHrb8BKKZ2uUyWtXWojlkJE/hqAw2Oq0yihedlYXIui+OC/X3ONOmqD1uk8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon-trash.png
// module id = 337
// module chunks = 0